import { parseBool, parseIntFromString } from '@/utils/parse-functions';

export default [
	{
		path: 'sales/finance-insurance/deal/:id',
		name: 'deal',
		meta: {
			pageTitle: 'Deal',
			hideNavigation: true
		},
		props: route => ({
			id: parseInt(route.params.id),
			titleIntegrationId: parseIntFromString(route.query.tiid),
			dealNumber: route.query.dealNumber,
			modal: route.query.modal,
			frame: parseBool(route.query.frame)
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "deal" */ '@/sections/sales/finance-insurance/deal/deal-page.vue'
			)
	},
	{
		path: 'sales/credit-request/scenario/:id',
		name: 'CreditRequest',
		meta: {
			pageTitle: 'Credit Request',
			hideNavigation: true
		},
		props: route => ({
			id: parseInt(route.params.id),
			deal: route.query.deal,
			frame: parseBool(route.query.frame),
			isProspect: parseBool(route.query.isProspect)
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "N/A" */ '@/sections/sales/finance-insurance/deal/credit/credit-request-modal.vue'
			)
	},
	{
		path: 'sales/credit-application/scenario/:id',
		name: 'CreditApplication',
		meta: {
			pageTitle: 'Credit Application',
			hideNavigation: true
		},
		props: route => ({
			id: parseInt(route.params.id),
			frame: parseBool(route.query.frame),
			loadExistingApp: parseBool(route.query.loadExistingApp),
			isProspect: parseBool(route.query.isProspect),
			importFromCreditReport: parseBool(route.query.importFromCreditReport)
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "CreditApplication" */ '@/sections/sales/finance-insurance/deal/credit/credit-application-modal.vue'
			)
	},
	{
		path: 'sales/credit-application-import/deal/:id',
		name: 'CreditApplicationImport',
		meta: {
			pageTitle: 'Credit Application Import',
			hideNavigation: true
		},
		props: route => ({
			id: parseInt(route.params.id),
			frame: parseBool(route.query.frame),
			isProspect: parseBool(route.query.isProspect)
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "CreditApplicationImport" */ '@/sections/sales/finance-insurance/deal/credit/credit-application-import-modal.vue'
			)
	},
	{
		path: 'sales/credit-application-history/deal/:id',
		name: 'CreditApplicationHistory',
		meta: {
			pageTitle: 'Credit Application History',
			hideNavigation: true
		},
		props: route => ({
			id: parseInt(route.params.id),
			frame: parseBool(route.query.frame)
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "CreditApplication" */ '@/sections/sales/finance-insurance/deal/credit/credit-application-history-modal.vue'
			)
	},
	{
		path: 'sales/credit-reporting/scenario/:id',
		name: 'CreditReport',
		meta: {
			pageTitle: 'Credit Report',
			hideNavigation: true
		},
		props: route => ({
			id: parseInt(route.params.id),
			frame: parseBool(route.query.frame),
			loadExistingReport: parseBool(route.query.loadExistingReport),
			isProspect: parseBool(route.query.isProspect)
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "N/A" */ '@/sections/sales/finance-insurance/deal/credit/credit-report-modal.vue'
			)
	},
	{
		path: 'sales/credit-report-import/scenario/:id',
		name: 'CreditReportImport',
		meta: {
			pageTitle: 'Credit Report',
			hideNavigation: true
		},
		props: route => ({
			id: parseInt(route.params.id),
			frame: parseBool(route.query.frame),
			isProspect: parseBool(route.query.isProspect)
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "CreditReportImport" */ '@/sections/sales/finance-insurance/deal/credit/credit-report-import-modal.vue'
			)
	},
	{
		path: 'sales/credit-report-bureaus/scenario/:id',
		name: 'CreditReportBureaus',
		meta: {
			pageTitle: 'Credit Report Bureaus',
			hideNavigation: true
		},
		props: route => ({
			id: parseInt(route.params.id),
			frame: parseBool(route.query.frame)
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "CreditReportBureaus" */ '@/sections/sales/finance-insurance/deal/credit/credit-report-bureaus-modal.vue'
			)
	},
	{
		path: 'sales/credit-history-request',
		name: 'CreditHistoryRequest',
		meta: {
			pageTitle: 'Credit History Request',
			hideNavigation: true
		},
		props: route => ({
			companyId: route.query.companyId,
			attachmentGUID: route.query.attachmentGUID,
			extension: route.query.extension,
			fileType: route.query.fileType
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "CreditHistoryRequest" */ '@/sections/sales/finance-insurance/deal/credit/credit-history-request.vue'
			)
	}
];
